/** Default language to use when none is set. */
export const defaultLanguage = 'en-US';
